<ion-content fullscreen="true">
  <div (click)="dismiss.emit(); modal?.dismiss()">
    <img [src]="src" alt="" (click)="$event.stopPropagation()" />
  </div>
</ion-content>